export default __webpack_public_path__ + "static/media/charizard.79a2ff27.gif";